/**
 * Authentication and Authorization Types
 */

export enum UserRole {
  ADMIN = 'Admin',
  SUPERVISOR = 'Supervisor',
  SUCCESS_COACH = 'Success Coach',
  VIEWER = 'Viewer'
}

export interface User {
  staffID: number;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
  isActive: boolean;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface AuthResponse {
  success: boolean;
  user?: User;
  token?: string;
  message?: string;
}

export interface AuthContextType {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (credentials: LoginCredentials) => Promise<void>;
  logout: () => void;
  hasRole: (roles: UserRole[]) => boolean;
  showTimeoutWarning?: boolean;
  extendSession?: () => void;
}
